import { Mutations } from '../mutations/settings-mutations';
import { Actions } from '../actions/settings-actions';
import { Getters } from '../getters/settings-getters';
import { SETTINGS_OBJ } from '../../views/settings/const';

export const initialState = {
  enteredLicenseKey: '',
  inputsWithMenuSelectedOption: {
    'telemetry-db-max-size-component': 'MB',
    'telemtry-days-to-save-component': 'DAY',
    'disk-space-component': 'MB',
    'min-virtual-memory-component': 'MB',
    'min-physical-memory-component': 'MB',
    'floating-release-time-component': 'SEC',
    'time-period-space-component': 'DAYS',
    'report-interval-component': 'SEC',
    'offline-agents-component': 'DAYS',
  },
  inputsData: {},
  settingsLayout: {
    one: [
      {
        x: 0,
        y: 0,
        w: 2,
        h: 2,
        i: '0',
        c: 'column-chart',
      },
      {
        x: 2,
        y: 0,
        w: 2,
        h: 2,
        i: '1',
        c: 'line-chart',
      },
    ],
  },
  settingsList: {
    Agents: {
      Name: 'Agents',
      Data: {
        CPUUsage: { Name: 'CPU Usage', Val: 50, APIName: 'MinIdleLevel' },
        DiskSpace: { Name: 'Disk space', Val: '300', APIName: '' },
        CoreLimits: { Name: 'Core limits', Val: 4 },
      },
    },
    System: {
      Name: 'General',
      Data: {
        CoordinatorPort: { Name: 'Coordinator port', Val: '31005', APIName: '' },
        WebPort: { Name: 'Web port', Val: '31006', APIName: '' },
        HeartBeat: {
          Name: 'Heartbeat',
          Val: 30,
          addedLabel: ' sec',
          APIName: '',
        },
        Encryption: { Name: 'Encryption', Val: true },
        VersionUpdate: { Name: 'Version update', Val: false },
        Telemetry: { Name: 'Telemetry', Val: true },
        LastLicenseUpdate: { Name: 'Last license update', Val: '8/8/20 5:30 PM' },
        PreventSystemStandby: { Name: 'Prevent system standby state while service is running', Val: true, hideOnSummary: true },
        DontShowWindows: { Name: 'Don’t show Windows Firewall related messages', Val: false, hideOnSummary: true },
        CheckForUpdate: { Name: 'placehunny', Val: true, hideOnSummary: true },
      },
    },
    // Build: {
    //   Name: "Build",
    //   Data: {
    //     XXX: {Name: "XXX", Val: "XXX"},
    //     XXX2: {Name: "XXX2", Val: "XXXX"},
    //     XXX3: {Name: "XXX3", Val: "XXXXX"},
    //     XXXX: {Name: "XXXX", Val: "XXXXXX"},
    //   },
    // },
    // Cloud: {
    //   Name: "Cloud",
    //   Data: {
    //     XXX: {Name: "XXX", Val: "XXX"},
    //     XXX2: {Name: "XXX2", Val: "XXXX"},
    //     XXX3: {Name: "XXX3", Val: "XXXXX"},
    //     XXXX: {Name: "XXXX", Val: "XXXXXX"},
    //   },
    // }
  },
  processesList: [
    { Name: 'BuildService', Val: false, keep: true },
    { Name: 'cmd', Val: false, keep: true },
    { Name: 'cohost', Val: false, keep: true },
    { Name: 'CoordinatorSettings', Val: false, keep: true },
    { Name: 'CoordMonitor', Val: false, keep: true },
    { Name: 'CoordService', Val: false, keep: true },
    { Name: 'csrss', Val: false, keep: true },
  ],
  license: {},
  licenses: {
    Total: 15,
    On: 5,
    Off: 10,
    licList: [
      {
        Type: 'Owned',
        Name: 'ywhyohwhy1',
        On: true,
      },
      {
        Type: 'SingleUse',
        Name: 'ywhyohwhy2',
        On: false,
      },
      {
        Type: 'Azure',
        Name: 'ywhyohwhy3',
        On: false,
      },
      {
        Type: 'AWS',
        Name: 'ywhyohwhy4',
        On: false,
      },
    ],
  },
  portsValidations: {},
  regExpValidation: true,
  settingsFromCoord: {
    [SETTINGS_OBJ.MinIdleLevel]: 0.29999999999999999,
    [SETTINGS_OBJ.ReportInterval]: 10,
    [SETTINGS_OBJ.MaxWorkers]: 150,
    [SETTINGS_OBJ.AutoSubscribe]: true,
    [SETTINGS_OBJ.UpdateVersionOnSubscribe]: 1,
    [SETTINGS_OBJ.AllowSystemStandby]: 1,
    [SETTINGS_OBJ.MinDiskFree]: 500,
    [SETTINGS_OBJ.MinVirtualMem]: 200,
    [SETTINGS_OBJ.MinPhysicalMem]: 0,
    [SETTINGS_OBJ.IgnoreProcesses]: '',
    [SETTINGS_OBJ.IgnoreFirewall]: 0,
    [SETTINGS_OBJ.Port]: 31104,
    [SETTINGS_OBJ.UpdateVersionAlways]: 0,
    [SETTINGS_OBJ.CheckForUpdatesOnline]: 1,
    [SETTINGS_OBJ.RunCacheCleanup]: 1,
    [SETTINGS_OBJ.CacheCleanupInterval]: 1,
    [SETTINGS_OBJ.RunStatDBCleanup]: 1,
    [SETTINGS_OBJ.CleanDBPeriod]: 1,
    [SETTINGS_OBJ.AutoSubscribeCloudNode]: 1,
    [SETTINGS_OBJ.OfflinePeriodCloudNode]: 30,
    [SETTINGS_OBJ.AgentsUseSecureConnections]: 0,
    [SETTINGS_OBJ.TelemetryEnabled]: true,
    [SETTINGS_OBJ.BuildGroups]: null,
    [SETTINGS_OBJ.CoordinatorApiAccess]: true,
    [SETTINGS_OBJ.AllowAgentsSelfRegToBuildGroup]: true,
    [SETTINGS_OBJ.CoordAPIPort]: 31100,
    // not real fields yet
    [SETTINGS_OBJ.CoreLimits]: 2,
    [SETTINGS_OBJ.VersionUpdate]: true,
    [SETTINGS_OBJ.LastLicenseUpdate]: '6/6/66 6:66 PM',
    [SETTINGS_OBJ.CoordApiPort]: null,
    [SETTINGS_OBJ.SSLPort]: null,
    [SETTINGS_OBJ.SslCnValidationPattern]: null,
    [SETTINGS_OBJ.TelemetryDaysToSave]: null,
    [SETTINGS_OBJ.TelemetryDBMaxSize]: null,
    [SETTINGS_OBJ.FloatingReleaseTime]: null,
    [SETTINGS_OBJ.AutomaticBALicense]: null,
    [SETTINGS_OBJ.BackupCoordinator]: null,
    [SETTINGS_OBJ.BackupCoordNames]: null,
    [SETTINGS_OBJ.BackupCoordIPs]: null,
    [SETTINGS_OBJ.BackupCoordBuildNums]: null,
    [SETTINGS_OBJ.BackupCoordPorts]: null,
    [SETTINGS_OBJ.OtherCoordHost]: null,
    [SETTINGS_OBJ.OtherCoordPort]: null,
    [SETTINGS_OBJ.OtherCoordDisplay]: null,
    [SETTINGS_OBJ.OtherCoordBuildNum]: null,
  },
  dirtyState: [],
  cloudStatus: null,
  cloudUrl: '',
  backupCoordinatorStatus: {
    IsActive: false,
    IsBackup: false,
    IsUnreachable: false,
  },
};

export default {
  namespaced: true, // set to true in case we wish to use multiple modules at the same time
  state: initialState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};
